{
  "address": "refnrNncADccJPZEB5hHuiFVb3trY5LH39ykwMD59Ht",
  "metadata": {
    "name": "referral",
    "version": "0.1.0",
    "spec": "0.1.0",
    "description": "Created with Anchor"
  },
  "instructions": [
    {
      "name": "cancel_unstake",
      "discriminator": [
        64,
        65,
        53,
        227,
        125,
        153,
        3,
        167
      ],
      "accounts": [
        {
          "name": "unstake",
          "writable": true
        },
        {
          "name": "escrow",
          "writable": true,
          "relations": [
            "unstake"
          ]
        },
        {
          "name": "staking",
          "writable": true,
          "relations": [
            "unstake"
          ]
        },
        {
          "name": "owner",
          "signer": true,
          "relations": [
            "unstake"
          ]
        },
        {
          "name": "rent_receiver",
          "writable": true
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": []
    },
    {
      "name": "claim_penalty_fee",
      "discriminator": [
        61,
        213,
        181,
        228,
        50,
        115,
        39,
        74
      ],
      "accounts": [
        {
          "name": "staking",
          "writable": true
        },
        {
          "name": "token_vault",
          "writable": true,
          "relations": [
            "staking"
          ]
        },
        {
          "name": "token_mint",
          "relations": [
            "staking"
          ]
        },
        {
          "name": "fee_receiver_token_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "staking"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "token_mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140,
                151,
                37,
                143,
                78,
                36,
                137,
                241,
                187,
                61,
                16,
                41,
                20,
                142,
                13,
                131,
                11,
                90,
                19,
                153,
                218,
                255,
                16,
                132,
                4,
                142,
                123,
                216,
                219,
                233,
                248,
                89
              ]
            }
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "staking_authority",
          "address": "4bpqRsxyEmegayUrEN28FCqZwiCBSQhFkB7R4BxyTuGy"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": {
              "name": "ClaimPenaltyFeeParams"
            }
          }
        }
      ]
    },
    {
      "name": "close_escrow",
      "discriminator": [
        139,
        171,
        94,
        146,
        191,
        91,
        144,
        50
      ],
      "accounts": [
        {
          "name": "escrow",
          "writable": true
        },
        {
          "name": "staking",
          "writable": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "owner",
          "signer": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "rent_receiver",
          "writable": true
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "skip_close_if_non_empty",
          "type": "bool"
        }
      ]
    },
    {
      "name": "immediate_unstake",
      "discriminator": [
        125,
        55,
        141,
        200,
        252,
        133,
        78,
        54
      ],
      "accounts": [
        {
          "name": "escrow",
          "writable": true
        },
        {
          "name": "staking",
          "writable": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "token_vault",
          "writable": true,
          "relations": [
            "staking"
          ]
        },
        {
          "name": "token_mint",
          "relations": [
            "staking"
          ]
        },
        {
          "name": "owner_token_vault",
          "writable": true
        },
        {
          "name": "owner",
          "signer": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "staking_authority",
          "address": "4bpqRsxyEmegayUrEN28FCqZwiCBSQhFkB7R4BxyTuGy"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": {
              "name": "ImmediateUnstakeParams"
            }
          }
        }
      ]
    },
    {
      "name": "initialize_escrow",
      "discriminator": [
        243,
        160,
        77,
        153,
        11,
        92,
        48,
        209
      ],
      "accounts": [
        {
          "name": "staking",
          "writable": true
        },
        {
          "name": "escrow",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  101,
                  115,
                  99,
                  114,
                  111,
                  119
                ]
              },
              {
                "kind": "account",
                "path": "staking"
              },
              {
                "kind": "account",
                "path": "owner"
              }
            ]
          }
        },
        {
          "name": "owner"
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": []
    },
    {
      "name": "initialize_staking",
      "discriminator": [
        184,
        41,
        251,
        154,
        146,
        145,
        197,
        77
      ],
      "accounts": [
        {
          "name": "staking",
          "writable": true,
          "signer": true
        },
        {
          "name": "token_vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "staking"
              }
            ]
          }
        },
        {
          "name": "token_mint"
        },
        {
          "name": "staking_authority",
          "address": "4bpqRsxyEmegayUrEN28FCqZwiCBSQhFkB7R4BxyTuGy"
        },
        {
          "name": "owner"
        },
        {
          "name": "staking_penalty_fee_receiver"
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": {
              "name": "InitializeStakingParams"
            }
          }
        }
      ]
    },
    {
      "name": "stake",
      "discriminator": [
        206,
        176,
        202,
        18,
        200,
        209,
        179,
        108
      ],
      "accounts": [
        {
          "name": "staking",
          "writable": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "escrow",
          "writable": true
        },
        {
          "name": "token_vault",
          "writable": true,
          "relations": [
            "staking"
          ]
        },
        {
          "name": "token_mint",
          "relations": [
            "staking"
          ]
        },
        {
          "name": "owner_token_vault",
          "writable": true
        },
        {
          "name": "owner",
          "signer": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": {
              "name": "StakeParams"
            }
          }
        }
      ]
    },
    {
      "name": "transfer_owner",
      "discriminator": [
        245,
        25,
        221,
        175,
        106,
        229,
        225,
        45
      ],
      "accounts": [
        {
          "name": "staking",
          "writable": true
        },
        {
          "name": "owner",
          "signer": true
        },
        {
          "name": "new_owner"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": []
    },
    {
      "name": "unstake",
      "discriminator": [
        90,
        95,
        107,
        42,
        205,
        124,
        50,
        225
      ],
      "accounts": [
        {
          "name": "unstake",
          "writable": true,
          "signer": true
        },
        {
          "name": "escrow",
          "writable": true
        },
        {
          "name": "staking",
          "writable": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "owner",
          "signer": true,
          "relations": [
            "escrow"
          ]
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": {
              "name": "UnstakeParams"
            }
          }
        }
      ]
    },
    {
      "name": "update_config",
      "discriminator": [
        29,
        158,
        252,
        191,
        10,
        83,
        219,
        99
      ],
      "accounts": [
        {
          "name": "staking",
          "writable": true
        },
        {
          "name": "owner",
          "signer": true
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "params",
          "type": {
            "defined": {
              "name": "UpdateConfigParams"
            }
          }
        }
      ]
    },
    {
      "name": "update_penalty_fee_receiver",
      "discriminator": [
        77,
        197,
        74,
        123,
        114,
        173,
        124,
        117
      ],
      "accounts": [
        {
          "name": "staking",
          "writable": true
        },
        {
          "name": "owner",
          "signer": true
        },
        {
          "name": "new_fee_receiver"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": []
    },
    {
      "name": "withdraw",
      "discriminator": [
        183,
        18,
        70,
        156,
        148,
        109,
        161,
        34
      ],
      "accounts": [
        {
          "name": "unstake",
          "writable": true
        },
        {
          "name": "escrow",
          "writable": true,
          "relations": [
            "unstake"
          ]
        },
        {
          "name": "staking",
          "writable": true,
          "relations": [
            "unstake"
          ]
        },
        {
          "name": "token_vault",
          "writable": true,
          "relations": [
            "staking"
          ]
        },
        {
          "name": "token_mint",
          "relations": [
            "staking"
          ]
        },
        {
          "name": "owner_token_vault",
          "writable": true
        },
        {
          "name": "owner",
          "signer": true,
          "relations": [
            "unstake"
          ]
        },
        {
          "name": "rent_receiver",
          "writable": true
        },
        {
          "name": "staking_authority",
          "address": "4bpqRsxyEmegayUrEN28FCqZwiCBSQhFkB7R4BxyTuGy"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "event_authority"
        },
        {
          "name": "program"
        }
      ],
      "args": []
    }
  ],
  "accounts": [
    {
      "name": "Escrow",
      "discriminator": [
        31,
        213,
        123,
        187,
        186,
        22,
        218,
        155
      ]
    },
    {
      "name": "Staking",
      "discriminator": [
        242,
        134,
        183,
        223,
        18,
        13,
        184,
        23
      ]
    },
    {
      "name": "Unstake",
      "discriminator": [
        154,
        148,
        131,
        67,
        52,
        244,
        244,
        19
      ]
    }
  ],
  "events": [
    {
      "name": "CancelUnstakeEvt",
      "discriminator": [
        230,
        63,
        92,
        158,
        107,
        126,
        230,
        39
      ]
    },
    {
      "name": "ClaimPenaltyFeeEvt",
      "discriminator": [
        228,
        41,
        121,
        236,
        21,
        69,
        166,
        71
      ]
    },
    {
      "name": "CloseEscrowEvt",
      "discriminator": [
        206,
        208,
        89,
        181,
        183,
        64,
        108,
        210
      ]
    },
    {
      "name": "ImmediateUnstakeEvt",
      "discriminator": [
        36,
        24,
        202,
        62,
        47,
        51,
        54,
        201
      ]
    },
    {
      "name": "InitializeEscrowEvt",
      "discriminator": [
        50,
        157,
        215,
        42,
        247,
        238,
        231,
        43
      ]
    },
    {
      "name": "InitializeStakingEvt",
      "discriminator": [
        133,
        42,
        50,
        158,
        52,
        137,
        101,
        142
      ]
    },
    {
      "name": "StakeEvt",
      "discriminator": [
        53,
        123,
        172,
        217,
        133,
        170,
        68,
        67
      ]
    },
    {
      "name": "TransferOwnerEvt",
      "discriminator": [
        197,
        207,
        122,
        118,
        106,
        171,
        112,
        89
      ]
    },
    {
      "name": "UnstakeEvt",
      "discriminator": [
        168,
        60,
        214,
        132,
        109,
        88,
        1,
        165
      ]
    },
    {
      "name": "UpdateConfigEvt",
      "discriminator": [
        39,
        182,
        200,
        158,
        81,
        7,
        69,
        254
      ]
    },
    {
      "name": "UpdatePenaltyFeeReceiverEvt",
      "discriminator": [
        37,
        29,
        255,
        198,
        43,
        220,
        10,
        94
      ]
    },
    {
      "name": "WithdrawEvt",
      "discriminator": [
        6,
        132,
        68,
        72,
        106,
        106,
        131,
        225
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "InvalidInputParams",
      "msg": "Invalid input parameters"
    },
    {
      "code": 6001,
      "name": "MathOverflow",
      "msg": "Math overflow"
    },
    {
      "code": 6002,
      "name": "UnsupportedTokenMint",
      "msg": "Unsupported token mint"
    },
    {
      "code": 6003,
      "name": "BelowMinimumStakeAmount",
      "msg": "Below minimum stake amount"
    },
    {
      "code": 6004,
      "name": "UnstakeNotReady",
      "msg": "Unstake not ready for withdrawal"
    },
    {
      "code": 6005,
      "name": "CannotCloseNonEmptyEscrow",
      "msg": "Cannot close non-empty escrow"
    },
    {
      "code": 6006,
      "name": "Unauthorized",
      "msg": "Unauthorized"
    },
    {
      "code": 6007,
      "name": "InvalidFeeReceiver",
      "msg": "Invalid fee receiver"
    },
    {
      "code": 6008,
      "name": "NothingToUnstake",
      "msg": "Nothing to unstake"
    },
    {
      "code": 6009,
      "name": "UnstakeDisabled",
      "msg": "Unstake is disabled. Use immediate unstake instead."
    },
    {
      "code": 6010,
      "name": "SlippageExceeded",
      "msg": "Slippage exceeded"
    },
    {
      "code": 6011,
      "name": "InvalidNewOwner",
      "msg": "Invalid new owner"
    },
    {
      "code": 6012,
      "name": "InvalidOwner",
      "msg": "Invalid owner"
    },
    {
      "code": 6013,
      "name": "InvalidTokenAccount",
      "msg": "Invalid token account"
    }
  ],
  "types": [
    {
      "name": "CancelUnstakeEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "Escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "unstake",
            "docs": [
              "The unstake account created for this unstake"
            ],
            "type": "pubkey"
          },
          {
            "name": "rent_receiver",
            "docs": [
              "The account that receives the lamports from closing the unstake account"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow_amount_latest",
            "docs": [
              "Latest escrow amount after the unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "staking_amount_latest",
            "docs": [
              "Latest staking amount after the unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "cancelled_amount",
            "docs": [
              "The amount successfully cancelled from the unstake account"
            ],
            "type": "u64"
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "ClaimPenaltyFeeEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "staking",
            "docs": [
              "The staking account"
            ],
            "type": "pubkey"
          },
          {
            "name": "fee_receiver",
            "docs": [
              "The token account that receives the claimed penalty fee"
            ],
            "type": "pubkey"
          },
          {
            "name": "claimed_fee_amount",
            "docs": [
              "The amount of penalty fee claimed"
            ],
            "type": "u64"
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking_penalty_fee_latest",
            "docs": [
              "Latest staking penalty fee after the claim"
            ],
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "ClaimPenaltyFeeParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "max_amount",
            "docs": [
              "The maximum amount of penalty fee to claim. Pass in u64::MAX to claim all available penalty fee."
            ],
            "type": "u64"
          },
          {
            "name": "padding0",
            "docs": [
              "Padding for future use."
            ],
            "type": {
              "array": [
                "u64",
                8
              ]
            }
          }
        ]
      }
    },
    {
      "name": "CloseEscrowEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "Escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "rent_receiver",
            "docs": [
              "The account that receives the lamports from closing the escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "total_escrow",
            "docs": [
              "Total number of escrow accounts after closing this escrow"
            ],
            "type": "u64"
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "ConfigFields",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "UnstakeCooldownSeconds",
            "fields": [
              "u64"
            ]
          },
          {
            "name": "MinStakingAmount",
            "fields": [
              "u64"
            ]
          },
          {
            "name": "ImmediateUnstakePenaltyFeeRateBps",
            "fields": [
              "u16"
            ]
          }
        ]
      }
    },
    {
      "name": "Escrow",
      "serialization": "bytemuck",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "staking",
            "docs": [
              "Staking account this escrow belongs to"
            ],
            "type": "pubkey"
          },
          {
            "name": "owner",
            "docs": [
              "Owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "staked_amount",
            "docs": [
              "Amount of tokens staked in this escrow"
            ],
            "type": "u64"
          },
          {
            "name": "partial_unstaked_amount",
            "docs": [
              "Amount of tokens that have been unstaked but not yet withdrawn"
            ],
            "type": "u64"
          },
          {
            "name": "padding0",
            "docs": [
              "Padding reserved for future use"
            ],
            "type": {
              "array": [
                "u64",
                24
              ]
            }
          }
        ]
      }
    },
    {
      "name": "ImmediateUnstakeEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "Escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow_amount_latest",
            "docs": [
              "Latest escrow amount after the immediate unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "staking_amount_latest",
            "docs": [
              "Latest staking amount after the immediate unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "penalty_fee_bps",
            "docs": [
              "Penalty fee bps"
            ],
            "type": "u16"
          },
          {
            "name": "penalty_fee_amount",
            "docs": [
              "Penalty fee amount for the immediate unstake"
            ],
            "type": "u64"
          },
          {
            "name": "staking_penalty_fee_latest",
            "docs": [
              "Latest staking penalty fee after the immediate unstake"
            ],
            "type": "u64"
          },
          {
            "name": "penalty_fee_excluded_unstake_amount",
            "docs": [
              "Unstake amount user received"
            ],
            "type": "u64"
          },
          {
            "name": "receiver",
            "docs": [
              "The token account that receives the unstake token"
            ],
            "type": "pubkey"
          },
          {
            "name": "params",
            "docs": [
              "Immediate unstake params"
            ],
            "type": {
              "defined": {
                "name": "ImmediateUnstakeParams"
              }
            }
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          },
          {
            "name": "actual_unstake_amount",
            "docs": [
              "The actual total amount unstaked from escrow before penalty split"
            ],
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "ImmediateUnstakeParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "max_amount",
            "docs": [
              "The maximum amount of tokens to unstake. User can pass in u64::MAX to unstake the full amount."
            ],
            "type": "u64"
          },
          {
            "name": "max_immediate_unstake_penalty_bps",
            "docs": [
              "Slippage protection against penalty fee bps changes. Eg: Update penalty fee bps sandwich."
            ],
            "type": "u16"
          },
          {
            "name": "padding0",
            "type": {
              "array": [
                "u64",
                5
              ]
            }
          }
        ]
      }
    },
    {
      "name": "InitializeEscrowEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "payer",
            "docs": [
              "The payer who pays for the account rental"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "The escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "total_escrow",
            "docs": [
              "Total number of escrow accounts"
            ],
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "InitializeStakingEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the staking"
            ],
            "type": "pubkey"
          },
          {
            "name": "token_mint",
            "docs": [
              "The mint of the staking token"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account"
            ],
            "type": "pubkey"
          },
          {
            "name": "payer",
            "docs": [
              "The payer who pays for the account rental"
            ],
            "type": "pubkey"
          },
          {
            "name": "token_program",
            "docs": [
              "Token program used for staking"
            ],
            "type": "pubkey"
          },
          {
            "name": "params",
            "docs": [
              "Parameters for initializing the staking"
            ],
            "type": {
              "defined": {
                "name": "InitializeStakingParams"
              }
            }
          }
        ]
      }
    },
    {
      "name": "InitializeStakingParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "unstake_cooldown_seconds",
            "docs": [
              "The amount of seconds that a user has to wait after unstaking before they can withdraw their tokens"
            ],
            "type": "u64"
          },
          {
            "name": "min_staking_amount",
            "docs": [
              "The minimum amount of tokens that a user has to stake"
            ],
            "type": "u64"
          },
          {
            "name": "immediate_unstake_penalty_bps",
            "docs": [
              "The penalty in basis points (bps) for immediately withdraw upon unstaking"
            ],
            "type": "u16"
          },
          {
            "name": "padding",
            "type": {
              "array": [
                "u64",
                10
              ]
            }
          }
        ]
      }
    },
    {
      "name": "StakeEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "Escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "payer",
            "docs": [
              "Payer who pay for stake amount"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow_amount_latest",
            "docs": [
              "Latest escrow amount after the stake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "staking_amount_latest",
            "docs": [
              "Latest staking amount after the stake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "params",
            "docs": [
              "Stake params"
            ],
            "type": {
              "defined": {
                "name": "StakeParams"
              }
            }
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "StakeParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "amount",
            "docs": [
              "The amount of tokens to stake"
            ],
            "type": "u64"
          },
          {
            "name": "padding",
            "type": {
              "array": [
                "u64",
                5
              ]
            }
          }
        ]
      }
    },
    {
      "name": "Staking",
      "serialization": "bytemuck",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the staking"
            ],
            "type": "pubkey"
          },
          {
            "name": "token_vault",
            "docs": [
              "The token vault that holds the staked tokens"
            ],
            "type": "pubkey"
          },
          {
            "name": "token_mint",
            "docs": [
              "The mint of the staked tokens"
            ],
            "type": "pubkey"
          },
          {
            "name": "staked_amount",
            "docs": [
              "The amount of tokens that the user has staked"
            ],
            "type": "u64"
          },
          {
            "name": "partial_unstaked_amount",
            "docs": [
              "The amount of tokens that the user has unstaked but not yet withdrawn"
            ],
            "type": "u64"
          },
          {
            "name": "penalty_fee_amount",
            "docs": [
              "The penalty fee amount for immediate unstaking that has been accumulated but not yet claimed"
            ],
            "type": "u64"
          },
          {
            "name": "config",
            "docs": [
              "Staking configuration"
            ],
            "type": {
              "defined": {
                "name": "StakingConfig"
              }
            }
          },
          {
            "name": "metrics",
            "docs": [
              "Staking metrics"
            ],
            "type": {
              "defined": {
                "name": "StakingMetrics"
              }
            }
          },
          {
            "name": "padding0",
            "type": {
              "array": [
                "u64",
                24
              ]
            }
          },
          {
            "name": "padding1",
            "type": {
              "array": [
                "u64",
                24
              ]
            }
          }
        ]
      }
    },
    {
      "name": "StakingAmountLatest",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "staked_amount",
            "docs": [
              "New staked amount after the change"
            ],
            "type": "u64"
          },
          {
            "name": "partial_unstaked_amount",
            "docs": [
              "New partial unstaked amount after the change"
            ],
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "StakingConfig",
      "serialization": "bytemuck",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "unstake_cooldown_seconds",
            "docs": [
              "The amount of seconds that a user has to wait after unstaking before they can withdraw their tokens"
            ],
            "type": "u64"
          },
          {
            "name": "min_staking_amount",
            "docs": [
              "The minimum amount of tokens that a user has to stake"
            ],
            "type": "u64"
          },
          {
            "name": "immediate_unstake_penalty_bps",
            "docs": [
              "The penalty in basis points (bps) for immediately withdraw upon unstaking"
            ],
            "type": "u16"
          },
          {
            "name": "padding0",
            "type": {
              "array": [
                "u8",
                6
              ]
            }
          },
          {
            "name": "fee_receiver",
            "docs": [
              "The account that receives the staking penalty fees"
            ],
            "type": "pubkey"
          },
          {
            "name": "padding1",
            "type": {
              "array": [
                "u64",
                24
              ]
            }
          }
        ]
      }
    },
    {
      "name": "StakingConfigEvt",
      "docs": [
        "Borsh-serializable mirror of `StakingConfig` for use in events.",
        "`#[zero_copy]` on `StakingConfig` provides bytemuck-based AnchorSerialize/Deserialize,",
        "which is incompatible with the borsh-based `#[event]` macro."
      ],
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "unstake_cooldown_seconds",
            "type": "u64"
          },
          {
            "name": "min_staking_amount",
            "type": "u64"
          },
          {
            "name": "immediate_unstake_penalty_bps",
            "type": "u16"
          },
          {
            "name": "padding0",
            "type": {
              "array": [
                "u8",
                6
              ]
            }
          },
          {
            "name": "fee_receiver",
            "type": "pubkey"
          },
          {
            "name": "padding1",
            "type": {
              "array": [
                "u64",
                24
              ]
            }
          }
        ]
      }
    },
    {
      "name": "StakingMetrics",
      "serialization": "bytemuck",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "total_escrow_count",
            "docs": [
              "The total number of escrows belongs to this staking account"
            ],
            "type": "u64"
          },
          {
            "name": "padding0",
            "docs": [
              "Padding for future metrics"
            ],
            "type": {
              "array": [
                "u64",
                12
              ]
            }
          }
        ]
      }
    },
    {
      "name": "TransferOwnerEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "old_owner",
            "docs": [
              "The old owner of the staking account"
            ],
            "type": "pubkey"
          },
          {
            "name": "new_owner",
            "docs": [
              "The new owner of the staking account"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account"
            ],
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "Unstake",
      "serialization": "bytemuck",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the partial unstake"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "The escrow account associated with the partial unstake"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the partial unstake"
            ],
            "type": "pubkey"
          },
          {
            "name": "amount",
            "docs": [
              "The amount of tokens that the user has partially unstaked but not yet withdrawn"
            ],
            "type": "u64"
          },
          {
            "name": "withdrawable_timestamp",
            "docs": [
              "The timestamp when the user can withdraw their unstaked tokens"
            ],
            "type": "u64"
          },
          {
            "name": "padding0",
            "docs": [
              "Padding for future use"
            ],
            "type": {
              "array": [
                "u64",
                12
              ]
            }
          }
        ]
      }
    },
    {
      "name": "UnstakeEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "Escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "unstake",
            "docs": [
              "The unstake account created for this unstake"
            ],
            "type": "pubkey"
          },
          {
            "name": "payer",
            "docs": [
              "The payer who pays for the unstake account rental"
            ],
            "type": "pubkey"
          },
          {
            "name": "actual_unstake_amount",
            "docs": [
              "The actual unstake amount processed"
            ],
            "type": "u64"
          },
          {
            "name": "escrow_amount_latest",
            "docs": [
              "Latest escrow amount after the unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "staking_amount_latest",
            "docs": [
              "Latest staking amount after the unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "params",
            "docs": [
              "Unstake params"
            ],
            "type": {
              "defined": {
                "name": "UnstakeParams"
              }
            }
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          },
          {
            "name": "withdrawable_timestamp",
            "docs": [
              "The timestamp when the user can withdraw the unstaked tokens"
            ],
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "UnstakeParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "max_amount",
            "docs": [
              "The maximum amount of tokens to unstake. User can pass in u64::MAX to unstake the full amount."
            ],
            "type": "u64"
          },
          {
            "name": "padding0",
            "type": {
              "array": [
                "u64",
                5
              ]
            }
          }
        ]
      }
    },
    {
      "name": "UpdateConfigEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the config update"
            ],
            "type": "pubkey"
          },
          {
            "name": "owner",
            "docs": [
              "The owner who updates the config"
            ],
            "type": "pubkey"
          },
          {
            "name": "old_config",
            "docs": [
              "The old config before the update"
            ],
            "type": {
              "defined": {
                "name": "StakingConfigEvt"
              }
            }
          },
          {
            "name": "new_config",
            "docs": [
              "The new config after the update"
            ],
            "type": {
              "defined": {
                "name": "StakingConfigEvt"
              }
            }
          }
        ]
      }
    },
    {
      "name": "UpdateConfigParams",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "fields_to_update",
            "type": {
              "vec": {
                "defined": {
                  "name": "ConfigFields"
                }
              }
            }
          },
          {
            "name": "padding0",
            "type": {
              "array": [
                "u64",
                8
              ]
            }
          }
        ]
      }
    },
    {
      "name": "UpdatePenaltyFeeReceiverEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the operator"
            ],
            "type": "pubkey"
          },
          {
            "name": "old_fee_receiver",
            "docs": [
              "The old fee receiver"
            ],
            "type": "pubkey"
          },
          {
            "name": "new_fee_receiver",
            "docs": [
              "The new fee receiver"
            ],
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "WithdrawEvt",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "owner",
            "docs": [
              "The owner of the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow",
            "docs": [
              "Escrow account"
            ],
            "type": "pubkey"
          },
          {
            "name": "staking",
            "docs": [
              "The staking account associated with the escrow"
            ],
            "type": "pubkey"
          },
          {
            "name": "unstake",
            "docs": [
              "The unstake account created for this unstake"
            ],
            "type": "pubkey"
          },
          {
            "name": "unstake_amount",
            "docs": [
              "The unstake amount"
            ],
            "type": "u64"
          },
          {
            "name": "rent_receiver",
            "docs": [
              "The account that receives the lamports from closing the unstake account"
            ],
            "type": "pubkey"
          },
          {
            "name": "receiver",
            "docs": [
              "The token account that receives the unstake token"
            ],
            "type": "pubkey"
          },
          {
            "name": "escrow_amount_latest",
            "docs": [
              "Latest escrow amount after the unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "staking_amount_latest",
            "docs": [
              "Latest staking amount after the unstake"
            ],
            "type": {
              "defined": {
                "name": "StakingAmountLatest"
              }
            }
          },
          {
            "name": "token_mint",
            "docs": [
              "The staking account token mint"
            ],
            "type": "pubkey"
          }
        ]
      }
    }
  ],
  "constants": [
    {
      "name": "MAXIMUM_UNSTAKE_COOLDOWN_SECONDS",
      "type": "u64",
      "value": "31536000"
    },
    {
      "name": "MINIMUM_UNSTAKE_COOLDOWN_SECONDS",
      "type": "u64",
      "value": "86400"
    }
  ]
}